import {
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Button,
  Grid2,
  Card,
  Tooltip,
} from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import { useGlobalModalContext } from "../../context/GlobalModalContext";
import EmailMeetingMinuteDialog from "./EmailMeetingMinuteDialog";
import GenerateMeetingMinuteDialog from "./GenerateMeetingMinuteDialog";
import MeetingSchedulerDialog from "./MeetingSchedulerDialog";
import CustomTable from "../CustomTable";
import { saveAs } from "file-saver";
import { useState } from "react";
import CustomTooltip from "../CustomTooltip";

const MeetingMinuteDialog = ({ data }) => {
  const { showModal, hideAllModal, hideModal } = useGlobalModalContext();

  const columns = [
    { name: "Serial Number", id: "Serial Number", width: "10%" },
    { name: "Action Item Name", id: "Action Item Name", width: "25%" },
    {
      name: "Action Item Description",
      id: "Action Item Description",
      width: "30%",
    },
    { name: "Owner", id: "Owner", width: "10%" },
    { name: "Target Date", id: "Target Date", width: "15%" },
    { name: "Status", id: "Status", width: "10%" },
  ];

  //const downloadJsonFile = () => {}
  const downloadJsonFile = () => {
    const element = document.querySelector("#meeting-minute-content"); // Target your component
    if (!element) return;
  
    // Get inline styles
    const styles = Array.from(document.styleSheets)
      .map((styleSheet) => {
        try {
          return Array.from(styleSheet.cssRules).map((rule) => rule.cssText).join("\n");
        } catch (error) {
          return "";
        }
      })
      .join("\n");
  
    const htmlContent = `
      <html>
        <head>
          <meta charset="UTF-8">
          <title>Meeting Minutes</title>
          <style>${styles}</style>
        </head>
        <body>
          ${element.outerHTML}
        </body>
      </html>`;
  
    const blob = new Blob([htmlContent], { type: "text/html" });
    saveAs(blob, "Meeting_Minutes.html");
  };
  

  return (
    <Dialog open onClose={hideModal} maxWidth={"md"} fullWidth={true}>
      <DialogTitle>
        <h4 className="font-bold text-center">Generated Meeting Minutes </h4>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={hideModal}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseOutlined />
      </IconButton>
      <DialogContent>
      <div id="meeting-minute-content">
        <Grid2 container direction={"row"} rowGap={2}>
          <Card sx={{ width: "100%" }}>
            <Grid2 m={2}>
              <div className="text-xs leading-5">
                <p>
                  <span className="font-bold">Title:</span>{" "}
                  {data?.mom_summary["Title"] || ""}
                </p>
                <p>
                  <span className="font-bold">Meeting Date and Time: </span>{" "}
                  {data?.mom_summary["Meeting Date and Time"] || ""}
                </p>
                <p>
                  <span className="font-bold">Participiants:</span>{" "}
                  {data?.mom_summary["Participants"]?.join(",") || ""}
                </p>
                <p>
                  <span className="font-bold">Participiant Emails:</span>{" "}
                  {data?.mom_summary["Participant Emails"]?.join(",") || ""}
                </p>

                <div className="mt-3">
                  <p className="font-bold mt-3">Decision Item Table:</p>
                  <CustomTable
                    columns={columns}
                    data={data?.mom_summary["Decision Item Table"] || []}
                    hidePagination
                  />
                </div>
                <div className="mt-5">
                  <p className="font-bold mt-3">Discussion Points:</p>
                  <ul className="list-disc ml-5">
                    {data?.mom_summary["Discussion points"].map(
                      (item, index) => (
                        <li key={index}>{item}</li>
                      )
                    )}
                  </ul>
                </div>
                <div className="mt-5">
                  <span className="font-bold ">Next Meeting Date:</span>{" "}
                  {data?.mom_summary["Next Meeting Date"] || ""}
                </div>
              </div>
            </Grid2>
          </Card>
        </Grid2>
        <Grid2
          container
          my={2}
          direction={"row"}
          gap={1}
          sx={{ justifyContent: "center" }}
        >
          <Grid2>
            <Button
              onClick={downloadJsonFile}
              variant="contained"
              size="small"
              sx={{ textTransform: "none" }}
            >
              Download MOM
            </Button>
          </Grid2>
          <Grid2>
            <Button
              onClick={() =>
                showModal(
                  <EmailMeetingMinuteDialog
                    emails={
                      data?.mom_summary['Participant Emails']
                        ? data?.mom_summary['Participant Emails'].join(";")
                        : ""
                    }
                  />
                )
              }
              variant="contained"
              size="small"
              sx={{ textTransform: "none" }}
            >
              Email MOM
            </Button>
          </Grid2>
          <Grid2>
            <Button
              onClick={() =>
                showModal(
                  <MeetingSchedulerDialog
                    emails={
                      data?.mom_summary['Participant Emails']
                        ? data?.mom_summary['Participant Emails']?.join(";")
                        : ""
                    }
                    dateTime={data?.mom_summary['Meeting Date and Time'] || ''}
                  />
                )
              }
              variant="contained"
              size="small"
              sx={{ textTransform: "none" }}
            >
              Schedule Meeting
            </Button>
          </Grid2>

          <Grid2>
            <CustomTooltip title="Functionality not yet integrated.">
            <Button
              onClick={() =>{}}
              variant="contained"
              size="small"
              sx={{ textTransform: "none" }}
            >
              Add to Previous Meetings
            </Button>
            </CustomTooltip>
          </Grid2>
        </Grid2>
        {/* <Grid2
          container
          my={2}
          direction={"row"}
          gap={1}
          sx={{ justifyContent: "center" }}
        >
          <Grid2>
            <Button
              onClick={() => {
                hideAllModal();
                showModal(<GenerateMeetingMinuteDialog />);
              }}
              variant="contained"
              color="inherit"
              size="small"
              sx={{ textTransform: "none" }}
            >
              Generate Another
            </Button>
          </Grid2>
        </Grid2> */}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MeetingMinuteDialog;
